import { observer } from "mobx-react-lite";
import { formatDate } from "../../utils/utils";
import infoStyles from '../Info.module.css';

function SavedViewInfo({ name, isShared, modifiedDate, createdBy, className, controls, onClick }: ISavedViewInfoProps) {
    return (
        <div className={[infoStyles.flexContainer, className].join(" ")} onClick={onClick}>
            <div>
                <div className={infoStyles.title}>{name}</div>
                <div className={infoStyles.description}>{isShared ? "Shared view" : "Private view"} {formatDate(modifiedDate)}</div>
                <div className={infoStyles.description}>{createdBy}</div>
            </div>
            <div>{controls}</div>
        </div>
    );
}

export interface ISavedViewInfoProps {
    name: string;
    isShared?: boolean;
    modifiedDate: Date;
    createdBy: string;
    className?: string;
    controls?: React.ReactNode[];
    onClick?: () => void;
}

export default observer(SavedViewInfo);
